/**
 * Phase 5 has a single sort ({@code recent}); the affordance is a static label. Lifting it to a
 * real {@code Select} drops in cleanly when more sorts arrive — keeping the component name and
 * placement stable now means that change won't ripple.
 */
export const BrowseSortSelect = () => (
  <div
    className="flex h-11 items-center rounded-md border border-input bg-background px-3 text-sm"
    aria-label="Sort by"
  >
    <span className="text-muted-foreground">Sort:</span>
    <span className="ml-2 font-medium">Recent</span>
  </div>
)
